import { render, staticRenderFns } from "./RegisterUserDoc.vue?vue&type=template&id=6a28ad70&"
import script from "./RegisterUserDoc.vue?vue&type=script&lang=js&"
export * from "./RegisterUserDoc.vue?vue&type=script&lang=js&"
import style0 from "./RegisterUserDoc.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports